// extracted by mini-css-extract-plugin
export var actions = "_4e-0";
export var actionsContainer = "_4e-6";
export var border = "_4e-1";
export var childFullHeight = "_4e-d";
export var collapse = "_4e-2";
export var content = "_4e-8";
export var contentChild = "_4e-c";
export var fullscreen = "_4e-a";
export var hasLeftRadius = "_4e-h";
export var headerContainer = "_4e-3";
export var headerRow = "_4e-5";
export var hidePadding = "_4e-9";
export var navCollapsedGap = "_4e-i";
export var noScrollX = "_4e-j";
export var noScrollY = "_4e-k";
export var optOutTopPadding = "_4e-b";
export var pageMain = "_4e-g";
export var pageOuter = "_4e-e";
export var pagePadding = "_4e-7";
export var profile = "_4e-l";
export var profileContainer = "_4e-m";
export var profileImage = "_4e-n";
export var profileMain = "_4e-o";
export var profileSubtitle = "_4e-q";
export var profileTitle = "_4e-p";
export var showLeftPadding = "_4e-f";
export var tabsWrapper = "_4e-4";
export var title = "_4e-r";